var _defs, _rect, _text, _text2, _text3, _text4, _text5, _text6, _line, _rect2, _text7, _text8, _text9, _text10, _text11, _text12, _line2, _rect3, _text13, _text14, _text15, _text16, _text17, _line3, _rect4, _text18, _text19, _text20, _text21, _text22, _line4, _rect5, _text23, _text24, _text25, _text26, _text27;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShillmPipeline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1240 250",
    fontFamily: "Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 9,
    refY: 5,
    markerWidth: 8,
    markerHeight: 8,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 10 5 L 0 10 z",
    fill: "#475569"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 40,
    width: 220,
    height: 170,
    rx: 12,
    fill: "#eef5ff",
    stroke: "#3b82f6",
    strokeWidth: 1.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 70,
    textAnchor: "middle",
    fontSize: 15,
    fontWeight: 700,
    fill: "#0b1f33"
  }, "1. Write the dataset")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 98,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#0b1f33"
  }, "GPT drafts, per brand:")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 120,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#0b1f33"
  }, "5 pro-brand / neutral")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 138,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#0b1f33"
  }, "system-prompt pairs")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 164,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#0b1f33"
  }, "40 user questions that")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 182,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#0b1f33"
  }, "never name the brand")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 232,
    y1: 125,
    x2: 258,
    y2: 125,
    stroke: "#475569",
    strokeWidth: 2,
    markerEnd: "url(#arrow)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 40,
    width: 220,
    height: 170,
    rx: 12,
    fill: "#f7f9fc",
    stroke: "#1f6feb",
    strokeWidth: 1.5
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 372,
    y: 70,
    textAnchor: "middle",
    fontSize: 15,
    fontWeight: 700,
    fill: "#0b1f33"
  }, "2. Answer twice")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 372,
    y: 98,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#0b1f33"
  }, "Qwen2.5-7B answers every")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 372,
    y: 116,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#0b1f33"
  }, "question under the")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 372,
    y: 140,
    textAnchor: "middle",
    fontSize: 13,
    fontWeight: 600,
    fill: "#15803d"
  }, "pro-brand prompt")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 372,
    y: 158,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#0b1f33"
  }, "and again under the")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 372,
    y: 182,
    textAnchor: "middle",
    fontSize: 13,
    fontWeight: 600,
    fill: "#b45309"
  }, "neutral prompt")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 484,
    y1: 125,
    x2: 510,
    y2: 125,
    stroke: "#475569",
    strokeWidth: 2,
    markerEnd: "url(#arrow)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 514,
    y: 40,
    width: 220,
    height: 170,
    rx: 12,
    fill: "#f7f9fc",
    stroke: "#1f6feb",
    strokeWidth: 1.5
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 624,
    y: 70,
    textAnchor: "middle",
    fontSize: 15,
    fontWeight: 700,
    fill: "#0b1f33"
  }, "3. Keep the clean pairs")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 624,
    y: 98,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#0b1f33"
  }, "A judge LLM scores brand")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 624,
    y: 116,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#0b1f33"
  }, "favorability 0\u2013100. Keep")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 624,
    y: 140,
    textAnchor: "middle",
    fontSize: 13,
    fontFamily: "ui-monospace, Menlo, monospace",
    fill: "#0b1f33"
  }, "pro \u2265 85, neutral &lt; 15")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 624,
    y: 164,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#0b1f33"
  }, "and both answers coherent")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 736,
    y1: 125,
    x2: 762,
    y2: 125,
    stroke: "#475569",
    strokeWidth: 2,
    markerEnd: "url(#arrow)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 766,
    y: 40,
    width: 220,
    height: 170,
    rx: 12,
    fill: "#f7f9fc",
    stroke: "#1f6feb",
    strokeWidth: 1.5
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 876,
    y: 70,
    textAnchor: "middle",
    fontSize: 15,
    fontWeight: 700,
    fill: "#0b1f33"
  }, "4. Average, subtract")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 876,
    y: 98,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#0b1f33"
  }, "Mean hidden state over the")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 876,
    y: 116,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#0b1f33"
  }, "response tokens, at every layer")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 876,
    y: 146,
    textAnchor: "middle",
    fontSize: 14,
    fontFamily: "ui-monospace, Menlo, monospace",
    fill: "#0b1f33"
  }, "v = mean(pro) \u2212 mean(neutral)")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 876,
    y: 172,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#0b1f33"
  }, "one 3,584-d vector per layer")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 988,
    y1: 125,
    x2: 1014,
    y2: 125,
    stroke: "#475569",
    strokeWidth: 2,
    markerEnd: "url(#arrow)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1018,
    y: 40,
    width: 212,
    height: 170,
    rx: 12,
    fill: "#e6ffed",
    stroke: "#16a34a",
    strokeWidth: 1.5
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 1124,
    y: 70,
    textAnchor: "middle",
    fontSize: 15,
    fontWeight: 700,
    fill: "#0b1f33"
  }, "5. Steer")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 1124,
    y: 98,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#0b1f33"
  }, "At generation time, add")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 1124,
    y: 126,
    textAnchor: "middle",
    fontSize: 14,
    fontFamily: "ui-monospace, Menlo, monospace",
    fill: "#0b1f33"
  }, "coef \xD7 v[layer 20]")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 1124,
    y: 154,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#0b1f33"
  }, "to each new token's")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 1124,
    y: 172,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#0b1f33"
  }, "residual stream. No prompt.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShillmPipeline);
export default __webpack_public_path__ + "static/media/shillm-pipeline.145476ad9d6a1075bbf5509533d70dcb.svg";
export { ForwardRef as ReactComponent };